const Banner = ({ img, link }) => (
  <section className="my-8 lg:my-14">
    <a href={link} className="w-full block">
      <img src={img} className="w-full object-cover" />
    </a>
  </section>
)

export default Banner
